import {
  Command,
  CommandList,
  OptionPanelSection,
  OptionPanelSeparator,
} from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";

import { QuickCustomRange } from "./quick-custom-range";
import type { QuickFilterOption } from "./quick-filter-options";
import { QuickOptionRow } from "./quick-option-row";

type QuickDatePageProps = Omittable<{
  /** The named windows, single-select — picking one replaces the last, and
   *  picking the applied one clears the filter. */
  options: QuickFilterOption[];
  value: unknown;
  onChange: (value: unknown) => void;
}>;

/**
 * The date-window page a date filter's row drills into on a phone: the named
 * presets as the same check rows every other drilled page uses, then the
 * two-date range the presets cannot enumerate (`QuickCustomRange`).
 *
 * Not the desktop submenu's body — that is menu markup, and a page is not a
 * menu — and not the shared `DateRangePresetPicker`, which is a Select whose
 * popup would open OVER the page the reader just arrived on. Both surfaces
 * write the same `DatePresetValue` from the one options index.
 */
export function QuickDatePage({ options, value, onChange }: QuickDatePageProps) {
  return (
    <>
      <Command mode="none" autoHighlight={false}>
        <CommandList>
          {options.map((option) => (
            <QuickOptionRow
              key={option.key}
              value={option.key}
              option={option}
              selected={option.selected(value)}
              onToggle={() => onChange(option.toggle(value))}
            />
          ))}
        </CommandList>
      </Command>
      <OptionPanelSeparator />
      <OptionPanelSection title="Custom range">
        <QuickCustomRange value={value} onChange={onChange} />
      </OptionPanelSection>
    </>
  );
}
